import { msg } from "@lit/localize";
import { isPresent } from "@whilecat/core/utils/objects.js";
import { stringToListItem } from "@whilecat/core/utils/string.js";
import { html, nothing } from "lit";

export function renderErrorOutput(actualOutput: string, expectedOutput?: string) {
    return html`
      ${renderBlock(msg("Output"), actualOutput)}
      ${renderBlock(msg("Expected"), expectedOutput)}
    `;
}

export function renderPlaceholderError() {
    return html`
      <p>
          ${msg("Have you forgotten to type the code?")}</br>
          ${msg(html`Please replace all <placeholder>{Type Here}</placeholder> entries.`)}
      </p>
    `;
}

function renderBlock(header: string, lines?: string) {
    if (!isPresent(lines)) {
        return nothing;
    }

    return html`
      <p>${header}:</p>
      ${renderOutput(lines!)}
    `;
}

export function renderOutput(lines: string) {
    return html`
      <ul style="list-style: none; padding-left: 0;">
        ${stringToListItem(lines!)}
      </ul>
    `;
}
